module.exports = "/_next/static/images/installation-c4ab9c268bbc3877db44af21d8e27b7e.webp";